import React from 'react';


export function FullCenterContentComponent({
    verticallyChidren,
    TagName = 'div',
    className = '',
    outerChidren,
    children
}) {
  
    return (
        <TagName className={`center-content ${className}`}>
            
            <div className="center-content-inner-wrapper">
                <div className="full-center">
                    <div className="vertically">
                        <div className="horizontally">
                            <div className="full-center-content">
                                {children}
                            </div>
                        </div>

                        {verticallyChidren}
                    </div>
                </div>
            </div>

            {outerChidren}
        </TagName>
    );
};